// returns text in current language from DB text in several languages
// example: [:pt]Viagens de aventura e natureza[:en]Adventure and nature trips[:] => language 'pt' => Viagens de aventura e natureza
export const lng = (value, language) => {
  if (value?.includes("[")) {
    const stringSegments = value.split("[");
    let langSegments = {};
    for (let i = 1; i < stringSegments.length - 1; i++) {
      const sub = stringSegments[i];
      langSegments[sub.substring(1, 3)] = sub.substring(4, sub.length);
    }
    return langSegments[language];
  } else return value;
};

export const languageName = (name, language) => {
  if (name?.includes("[:pt")) {
    let index = name.indexOf(`[:${language}]`);
    // if no translation, use portuguese
    if (index === -1) index = 0;
    const str = name.substring(index + 5);
    const indexEnd = str.indexOf(`[`);
    const finalStr = str.substring(0, indexEnd);

    return finalStr;
  } else return name;
};
